import { ComponentProps } from 'react';

import { Text } from '@spotify-internal/encore-web';

import { asDialogSlot } from './composition';
import { useDialogContext } from './context';

export type TitleProps = Omit<ComponentProps<typeof Text>, 'as'>;

export const Title = ({
  children,
  variant = 'titleLarge',
  ...rest
}: TitleProps) => {
  const { id } = useDialogContext();

  return (
    <Text id={`${id}-title`} as="h2" variant={variant} {...rest}>
      {children}
    </Text>
  );
};

Title.displayName = 'DialogComposite.Title';

asDialogSlot(Title, 'title');

export default Title;
